// El fondo del onboarding de marca (ADR-2026-10-01-onboarding-v2-cumbre-guia): una
// cordillera hecha con la silueta de Cumbre, que sube al entrar, y dos luces de la marca
// que se mueven lento. Decorativo: no recibe clicks ni se anuncia.

import { SILUETA_DE_CUMBRE } from '../../CumbreMascot';

/** x, y y escala de cada cerro sobre un lienzo de 1200×300. `d` ordena la subida. */
const CERROS = [
  { x: -60, y: 150, s: 0.9, capa: 'lejos', d: 3 },
  { x: 170, y: 95, s: 1.25, capa: 'lejos', d: 1 },
  { x: 470, y: 125, s: 1.05, capa: 'lejos', d: 4 },
  { x: 720, y: 80, s: 1.35, capa: 'lejos', d: 2 },
  { x: 1000, y: 140, s: 0.95, capa: 'lejos', d: 5 },
  { x: 40, y: 200, s: 0.8, capa: 'cerca', d: 6 },
  { x: 330, y: 185, s: 0.95, capa: 'cerca', d: 7 },
  { x: 610, y: 205, s: 0.75, capa: 'cerca', d: 8 },
  { x: 860, y: 190, s: 0.9, capa: 'cerca', d: 9 },
] as const;

export function FondoCordillera({ quieto }: { quieto: boolean }) {
  return (
    <div className={`om-fondo ${quieto ? 'om-fondo--quieto' : ''}`} aria-hidden="true">
      <span className="om-luz om-luz--cian" />
      <span className="om-luz om-luz--azul" />
      <svg className="om-cordillera" viewBox="0 0 1200 300" preserveAspectRatio="xMidYMax slice">
        <defs>
          <linearGradient id="om-cerro-lejos" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" style={{ stopColor: 'var(--brand-accent)' }} stopOpacity="0.32" />
            <stop offset="0.75" style={{ stopColor: 'var(--brand-accent)' }} stopOpacity="0" />
          </linearGradient>
          <linearGradient id="om-cerro-cerca" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" style={{ stopColor: 'var(--brand-primary)' }} stopOpacity="0.16" />
            <stop offset="0.7" style={{ stopColor: 'var(--brand-primary)' }} stopOpacity="0" />
          </linearGradient>
        </defs>
        {CERROS.map((c, i) => (
          <g key={i} transform={`translate(${c.x} ${c.y}) scale(${c.s})`}>
            <path
              className="om-cerro"
              d={SILUETA_DE_CUMBRE}
              fill={`url(#om-cerro-${c.capa})`}
              style={{ ['--d' as string]: c.d }}
            />
          </g>
        ))}
      </svg>
    </div>
  );
}

export default FondoCordillera;
